import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import { exitAlert } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import saveManager from '../../components/utils/SaveManager';
import recordedSoundUploadingUtils from '../../components/utils/RecordedSoundUploadingUtils';
import apiServiceUtils from '../utils/ApiServiceUtils';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index == 1) { //YES, button
            var href = saveManager.hrefLocationForIOS;

            if (href.length > 0)
                window.location.href = href;
        } else {
            this.props.dispatch(exitAlert(false));
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var fillColor;

        if (this.state.isOver == true) {
            fillColor = properties.SLIDE_VIEWER_BACKGROUND;
            textColor = 'black';
        } else if (this.props.index == 0) {
            textColor = 'black';
            fillColor = 'white';
        } else {
            textColor = 'white';
            fillColor = properties.DELETE_ALERT_BACKGROUND;
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: properties.DELETE_ALERT_BUTTON_WIDTH,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333'
        };

        const spanStyle = {
            position: 'absolute',
            top: 7,
            fontSize: 16,
            width: properties.DELETE_ALERT_BUTTON_WIDTH - 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        return (
            <div style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </div>
        );
    }
});

const ExitAlertContent = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.exitAlert != newProps.exitAlert || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight)
            return true;
        else
            return false;
    },
    render() {
        if (!this.props.exitAlert)
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: properties.DELETE_ALERT_BACKGROUND_OPACITY
        };

        const alertHolderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT / 2,
            left: this.props.windowWidth / 2 - properties.DELETE_ALERT_WIDTH / 2
        };

        var bottomHeight = properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 100;
        const bottomBarStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: properties.DELETE_ALERT_WIDTH,
            height: bottomHeight,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'white'
        };

        const questionStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 20,
            fontSize: 16,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            height: properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 3 * properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line'
        };

        var alertMessage;

        if (recordedSoundUploadingUtils.isUploadingCurrentSound)
            alertMessage = locales.getCaption('ExitAlertUnsavedRecording', 'other');
        else
            alertMessage = locales.getCaption('ExitAlert', 'other');

        return (
            <div style={menuStyle}>
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={bottomBarStyle}>
                        <div style={questionStyle}>{alertMessage}</div>
                        <Button dispatch={this.props.dispatch} topPosition={bottomHeight - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP - 2 * properties.DELETE_ALERT_BUTTON_WIDTH} index={0} text={locales.getCaption('DeleteAlertCancel', 'deleteAlert')}/>
                        <Button dispatch={this.props.dispatch} topPosition={bottomHeight - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT} leftPosition={properties.DELETE_ALERT_WIDTH - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_WIDTH} index={1} text={locales.getCaption('Yes', 'other')}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var exitAlert = state.menu.exitAlert;

    if (exitAlert == undefined)
        exitAlert = false;

    return {
        exitAlert
    };
}

export const ExitAlert = connect(mapStateToProps)(ExitAlertContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ExitAlert.js
 **/